import ParticularAccount from './ParticularAccount';
export default ParticularAccount;
